import { verify } from './SetupTOTP.commands';

export const mapStateToProps = () => {
    return {};
};

export const mapDispatchToProps = { verify };
